import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/recommendation/')({
  beforeLoad: () => {
    throw notFound();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/recommendation/"!</div>;
}
